import React, { useEffect, useState } from "react";
import "./NewPatientRegistration.css";

const AssetMaster = ({ screenAction , triggerSave}) => {

const initialState = {
asset_id:"",
asset_name:"",
category:"",
uom:"",
manufacturer:"",
model:"",
purchase_date:"",
purchase_cost:"",
warranty:"",
location:"",
responsible_staff:"",
maintenance_schedule:"",
status:"",
remarks:""
};

const [searchText,setSearchText] = useState("");
const [assets,setAssets] = useState([]);
const [showDropdown,setShowDropdown] = useState(false);
const [formData,setFormData] = useState(initialState);
const [isDisabled,setIsDisabled] = useState(true);

const handleChange = (e)=>{
const {name,value} = e.target;
setFormData({...formData,[name]:value});
};

const selectAsset = (asset) => {
  setFormData(asset);

  setSearchText(`${asset.asset_id} | ${asset.asset_name} | ${asset.location}`);
  setShowDropdown(false);

  if (screenAction === "edit") setIsDisabled(false);
  if (screenAction === "view") setIsDisabled(true);
};



const searchAssets = async (text) => {
  setSearchText(text);

  if (text.length < 2) {
    setAssets([]);
    return;
  }

  const user = JSON.parse(localStorage.getItem("user"));

  const res = await fetch(
    `https://hmsapi.emedhatechnologies.com/master/api/api/assets/search?q=${text}&employee_id=${user.id}`
  );

  const data = await res.json();

  setAssets(data);
  setShowDropdown(true);
};



const clearForm = () => {
  const date = new Date();
  const id = `AS-${date.getFullYear()}-${Math.floor(1000 + Math.random() * 9000)}`;

  setFormData({
    ...initialState,
    asset_id: id
  });

  setSearchText("");
  setIsDisabled(false);
};


const handleSubmit = async (e) => {
  if (e) e.preventDefault(); // ✅ IMPORTANT

  const user = JSON.parse(localStorage.getItem("user"));

  if (!formData.asset_name) {
    alert("Please enter asset name");
    return;
  }

  const payload = { ...formData };

  delete payload.created_at;
  delete payload.updated_at;

  payload.created_by = user.id;

  const method = formData.created_at || formData.hospital_id ? "PUT" : "POST";

  const url =
    method === "POST"
      ? "https://hmsapi.emedhatechnologies.com/master/api/api/assets"
      : `https://hmsapi.emedhatechnologies.com/master/api/api/assets/${formData.asset_id}`;

  try {
    const res = await fetch(url, {
      method,
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify(payload),
    });

    if (res.ok) {
      alert("Asset Saved Successfully!");

      if (method === "POST") {
        clearForm(); // ✅ NOW IT WILL WORK
      }
    }
  } catch (err) {
    console.error(err);
    alert("Network Error");
  }
};

const refreshForm = () => {
  if (formData.created_at) {
    fetch(`https://hmsapi.emedhatechnologies.com/master/api/api/assets/${formData.asset_id}`)
      .then(res => res.json())
      .then(data => setFormData(data));
  } else {
    clearForm();
  }
};


const printForm = () => {
  const newWindow = window.open("", "", "width=900,height=700");
  const today = new Date().toLocaleDateString();

  const htmlContent = `
    <html>
      <head>
        <title>Asset Details - ${formData.asset_id}</title>
        <style>
          body { font-family: 'Segoe UI', Tahoma; color: #333; padding: 40px; }

          .header {
            display: flex;
            justify-content: space-between;
            border-bottom: 2px solid #b8860b;
            margin-bottom: 20px;
            padding-bottom: 10px;
          }

          .hospital-info h1 {
            margin: 0;
            font-size: 22px;
            color: #2c3e50;
          }

          .hospital-info p {
            margin: 2px 0;
            font-size: 12px;
            color: #777;
          }

          .title {
            text-align: right;
          }

          .title h2 {
            margin: 0;
            color: #b8860b;
          }

          .section {
            margin-top: 20px;
          }

          .section-header {
            background: #fffcf2;
            padding: 8px;
            font-weight: bold;
            border-left: 4px solid #b8860b;
            margin-bottom: 10px;
          }

          .grid {
            display: grid;
            grid-template-columns: repeat(2, 1fr);
            gap: 10px;
          }

          .item {
            border-bottom: 1px dotted #ccc;
            padding: 5px 0;
            font-size: 13px;
            display: flex;
          }

          .label {
            width: 180px;
            font-weight: 600;
            color: #555;
          }

          .value {
            flex: 1;
            font-weight: 500;
          }

          .footer {
            margin-top: 50px;
            font-size: 10px;
            text-align: center;
            color: #999;
            border-top: 1px solid #eee;
            padding-top: 10px;
          }

          .sig-box {
            margin-top: 60px;
            display: flex;
            justify-content: space-between;
          }

          .sig {
            border-top: 1px solid #000;
            width: 200px;
            text-align: center;
            padding-top: 5px;
            font-size: 12px;
          }

          @media print {
            body { padding: 20px; }
            @page { margin: 0.5cm; }
          }
        </style>
      </head>

      <body>

        <div class="header">
          <div class="hospital-info">
            <h1>EMEDHA CARE HOSPITAL</h1>
            <p>Asset Management Department</p>
            <p>Phone: +91 98765 43210</p>
          </div>

          <div class="title">
            <h2>ASSET MASTER REPORT</h2>
            <p>Print Date: ${today}</p>
          </div>
        </div>

        <div class="section">
          <div class="section-header">Asset Identification</div>
          <div class="grid">
            <div class="item"><span class="label">Asset ID:</span><span class="value">${formData.asset_id}</span></div>
            <div class="item"><span class="label">Asset Name:</span><span class="value">${formData.asset_name}</span></div>
            <div class="item"><span class="label">Category:</span><span class="value">${formData.category}</span></div>
            <div class="item"><span class="label">UOM:</span><span class="value">${formData.uom}</span></div>
            <div class="item"><span class="label">Manufacturer:</span><span class="value">${formData.manufacturer}</span></div>
            <div class="item"><span class="label">Model:</span><span class="value">${formData.model}</span></div>
            <div class="item"><span class="label">Purchase Date:</span><span class="value">${formData.purchase_date}</span></div>
            <div class="item"><span class="label">Purchase Cost:</span><span class="value">${formData.purchase_cost}</span></div>
            <div class="item"><span class="label">Warranty:</span><span class="value">${formData.warranty}</span></div>
            <div class="item"><span class="label">Location:</span><span class="value">${formData.location}</span></div>
          </div>
        </div>

        <div class="section">
          <div class="section-header">Usage & Maintenance</div>
          <div class="grid">
            <div class="item"><span class="label">Responsible Staff:</span><span class="value">${formData.responsible_staff}</span></div>
            <div class="item"><span class="label">Maintenance:</span><span class="value">${formData.maintenance_schedule}</span></div>
            <div class="item"><span class="label">Status:</span><span class="value">${formData.status}</span></div>
            <div class="item"><span class="label">Remarks:</span><span class="value">${formData.remarks}</span></div>
          </div>
        </div>

        <div class="sig-box">
          <div class="sig">Authorized By</div>
          <div class="sig">Store Manager</div>
        </div>

        <div class="footer">
          This is a system-generated asset report for internal use.
        </div>

      </body>
    </html>
  `;

  newWindow.document.write(htmlContent);
  newWindow.document.close();

  setTimeout(() => {
    newWindow.print();
    newWindow.close();
  }, 500);
};


useEffect(() => {
  if (triggerSave > 0 && screenAction === "save") {
    handleSubmit();
  }
}, [triggerSave]);


useEffect(()=>{

if(screenAction === "add"){
 clearForm();
}

if(screenAction === "edit"){
 setIsDisabled(false);
}

if(screenAction === "view"){
 setIsDisabled(true);
}

// if(screenAction === "save"){
//  handleSubmit();
// }

if(screenAction === "refresh"){
 refreshForm();
}

if(screenAction === "print"){
 printForm();
}

},[screenAction]);



return(

<div className="registration-container fade-in" id="print-area">
{(screenAction === "edit" || screenAction === "view") && (

<div className="patient-search">

<label>Search Asset</label>

<input
 type="text"
 value={searchText}
 placeholder="Search by Asset ID / Name / Location / Category"
 onChange={(e)=>searchAssets(e.target.value)}
/>

{showDropdown && assets.length > 0 && (

<div className="patient-dropdown">

{assets.map((a)=>(

<div
 key={a.asset_id}
 className="patient-item"
 onClick={()=>selectAsset(a)}
>

{a.asset_id} | {a.asset_name} | {a.location} | {a.category}

</div>

))}

</div>

)}

</div>

)}
<form className="luxury-form" >

{/* ASSET IDENTIFICATION */}

<div className="form-section-header">
<h3>Asset Identification</h3>
</div>

<div className="form-grid">

<div className="input-box">
<label>Asset ID / Tag Number</label>
<input type="text" name="asset_id" onChange={handleChange} disabled={isDisabled}  value={formData.asset_id || ""}/>
</div>

<div className="input-box">
<label>Asset Name</label>
<select name="asset_name" onChange={handleChange} disabled={isDisabled}  value={formData.asset_name || ""}>
<option value="">Select Asset</option>
<option>Refrigerator</option>
<option>Computer</option>
<option>Scanner</option>
<option>Printer</option>
<option>ECG Machine</option>
</select>
</div>

<div className="input-box">
<label>Category / Type</label>
<select name="category" onChange={handleChange} disabled={isDisabled}  value={formData.category || ""}>
<option value="">Select</option>
<option>Medical</option>
<option>Office</option>
<option>IT</option>
</select>
</div>

<div className="input-box">
<label>UOM</label>
<select name="uom" onChange={handleChange} disabled={isDisabled}  value={formData.uom || ""}>
<option value="">Select</option>
<option>Nos</option>
<option>Units</option>
<option>Pieces</option>
</select>
</div>

<div className="input-box">
<label>Manufacturer</label>
<input type="text" name="manufacturer" onChange={handleChange} disabled={isDisabled} value={formData.manufacturer || ""}/>
</div>

<div className="input-box">
<label>Model</label>
<input type="text" name="model" onChange={handleChange} disabled={isDisabled} value={formData.model || ""}/>
</div>

<div className="input-box">
<label>Purchase Date</label>
<input type="date" name="purchase_date" onChange={handleChange} disabled={isDisabled} value={formData.purchase_date || ""}/>
</div>

<div className="input-box">
<label>Purchase Cost</label>
<input type="number" name="purchase_cost" onChange={handleChange} disabled={isDisabled} value={formData.purchase_cost || ""}/>
</div>

<div className="input-box">
<label>Warranty / AMC</label>
<input type="text" name="warranty" placeholder="Example: 2 Years AMC" onChange={handleChange} disabled={isDisabled} value={formData.warranty || ""}/>
</div>

<div className="input-box">
<label>Location</label>
<select name="location" onChange={handleChange} disabled={isDisabled} value={formData.location || ""}>
<option value="">Select Location</option>
<option>Storage Room</option>
<option>Pharmacy Counter</option>
<option>Laboratory</option>
<option>Reception</option>
<option>Doctor Room</option>
</select>
</div>

</div>


{/* ASSET USAGE & MAINTENANCE */}

<div className="form-section-header">
<h3>Asset Usage & Maintenance</h3>
</div>

<div className="form-grid">

<div className="input-box">
<label>Responsible Staff</label>
<select name="responsible_staff" onChange={handleChange} disabled={isDisabled} value={formData.responsible_staff || ""}>
<option value="">Select Staff</option>
<option>Pharmacist</option>
<option>Lab Technician</option>
<option>Receptionist</option>
<option>Admin</option>
</select>
</div>

<div className="input-box">
<label>Maintenance Schedule</label>
<select name="maintenance_schedule" onChange={handleChange} disabled={isDisabled} value={formData.maintenance_schedule || ""}>
<option value="">Select</option>
<option>Daily</option>
<option>Weekly</option>
<option>Monthly</option>
<option>Quarterly</option>
<option>Yearly</option>
</select>
</div>

<div className="input-box">
<label>Status</label>
<select name="status" onChange={handleChange} disabled={isDisabled} value={formData.status || ""}>
<option value="">Select</option>
<option>Active</option>
<option>Under Repair</option>
<option>Retired</option>
</select>
</div>

<div className="input-box full-width">
<label>Remarks</label>
<textarea name="remarks" onChange={handleChange} disabled={isDisabled} value={formData.remarks || ""}/>
</div>

</div>

</form>

</div>

);

};

export default AssetMaster;